var AssetDirectory = {
	"load": [
		"assets/bgm/bgm.ogg",
		"assets/fonts/airbagfree-regular.woff",
		"assets/fonts/londonbetween.woff",
		"assets/htp/htp_eden1.png",
		"assets/htp/htp_eden2.png",
		"assets/htp/htp_eden3.png",
		"assets/htp/htp_eden4.png",
		"assets/htp/htp_eden5.png",
		"assets/htp/htp_eden6.png",
		"assets/ingame/beartigerlion_anim_ske.json",
		"assets/ingame/beartigerlion_anim_tex.json",
		"assets/ingame/beartigerlion_anim_tex.png",
		"assets/ingame/bg_eden.png",
		"assets/ingame/deer_anim_ske.json",
		"assets/ingame/deer_anim_tex.json",
		"assets/ingame/deer_anim_tex.png",
		"assets/ingame/donkey_anim_ske.json",
		"assets/ingame/donkey_anim_tex.json",
		"assets/ingame/donkey_anim_tex.png",
		"assets/ingame/eden_prop1.png",
		"assets/ingame/eden_prop2.png",
		"assets/ingame/eden_prop3.png",
		"assets/ingame/eden_prop4.png",
		"assets/ingame/eden_prop5.png",
		"assets/ingame/eden_prop6.png",
		"assets/ingame/elephant_anim_ske.json",
		"assets/ingame/elephant_anim_tex.json",
		"assets/ingame/elephant_anim_tex.png",
		"assets/ingame/fx_firsttimeplay_glow.png",
		"assets/ingame/fx_glow_red.png",
		"assets/ingame/fx_glow_red2.png",
		"assets/ingame/fx_glow_white.png",
		"assets/ingame/fx_glow_white2.png",
		"assets/ingame/fx_glow_yellow.png",
		"assets/ingame/fx_glow_yellow2.png",
		"assets/ingame/fx_sparkle_ske.json",
		"assets/ingame/fx_sparkle_tex.json",
		"assets/ingame/fx_sparkle_tex.png",
		"assets/ingame/gazelle_anim_ske.json",
		"assets/ingame/gazelle_anim_tex.json",
		"assets/ingame/gazelle_anim_tex.png",
		"assets/ingame/giraffe_anim_ske.json",
		"assets/ingame/giraffe_anim_tex.json",
		"assets/ingame/giraffe_anim_tex.png",
		"assets/ingame/goat_anim_ske.json",
		"assets/ingame/goat_anim_tex.json",
		"assets/ingame/goat_anim_tex.png",
		"assets/ingame/goat_anim_ver2_ske.json",
		"assets/ingame/goat_anim_ver2_tex.json",
		"assets/ingame/goat_anim_ver2_tex.png",
		"assets/ingame/horse_anim_ske.json",
		"assets/ingame/horse_anim_tex.json",
		"assets/ingame/horse_anim_tex.png",
		"assets/ingame/monkeyslothlamb_anim_ske.json",
		"assets/ingame/monkeyslothlamb_anim_tex.json",
		"assets/ingame/monkeyslothlamb_anim_tex.png",
		"assets/ingame/pomegranate.png",
		"assets/ingame/pomegranate_expired.png",
		"assets/ingame/ram_anim_ske.json",
		"assets/ingame/ram_anim_tex.json",
		"assets/ingame/ram_anim_tex.png",
		"assets/ingame/rhino_anim_ske.json",
		"assets/ingame/rhino_anim_tex.json",
		"assets/ingame/rhino_anim_tex.png",
		"assets/sfx/animal_collect.ogg",
		"assets/sfx/bear.ogg",
		"assets/sfx/button_sfx.ogg",
		"assets/sfx/deer.ogg",
		"assets/sfx/donkey.ogg",
		"assets/sfx/elephant.ogg",
		"assets/sfx/gazelle.ogg",
		"assets/sfx/giraffe.ogg",
		"assets/sfx/goat.ogg",
		"assets/sfx/horse.ogg",
		"assets/sfx/lamb.ogg",
		"assets/sfx/lion.ogg",
		"assets/sfx/monkey.ogg",
		"assets/sfx/pick_fruit.ogg",
		"assets/sfx/ram.ogg",
		"assets/sfx/rhino.ogg",
		"assets/sfx/score_points.ogg",
		"assets/sfx/sloth.ogg",
		"assets/sfx/star_gain.ogg",
		"assets/sfx/success.ogg",
		"assets/sfx/tiger.ogg",
		"assets/titlescreen/bg_logo_eden.png",
		"assets/titlescreen/gizmo_eden.png",
		"assets/titlescreen/logo_eden1.png",
		"assets/titlescreen/logo_eden2.png",
		"assets/ui/btn_audio1.png",
		"assets/ui/btn_audio2.png",
		"assets/ui/btn_audio3.png",
		"assets/ui/btn_audio4.png",
		"assets/ui/btn_exit.png",
		"assets/ui/btn_exit2.png",
		"assets/ui/btn_pause.png",
		"assets/ui/btn_pause2.png",
		"assets/ui/btn_play.png",
		"assets/ui/btn_play2.png",
		"assets/ui/btn_prevnext.png",
		"assets/ui/btn_prevnext2.png",
		"assets/ui/btn_replay.png",
		"assets/ui/btn_replay2.png",
		"assets/ui/btn_return.png",
		"assets/ui/btn_return2.png",
		"assets/ui/check-button1.png",
		"assets/ui/check-button2.png",
		"assets/ui/gfx_container.png",
		"assets/ui/gfx_container_white.png",
		"assets/ui/gfx_explode.png",
		"assets/ui/gfx_flare_long.png",
		"assets/ui/gfx_flare_star.png",
		"assets/ui/gfx_loading_bar_con.png",
		"assets/ui/gfx_pop.png",
		"assets/ui/gfx_pop2.png",
		"assets/ui/gfx_star0.png",
		"assets/ui/gfx_star1.png",
		"assets/ui/gfx_starbg.png",
		"assets/ui/x-button1.png",
		"assets/ui/x-button2.png"
	],
	"preload": [
		"assets/preload/fonts/Exo-Bold.otf",
		"assets/preload/fonts/Exo-Medium.ttf",
		"assets/preload/fonts/Figtree.woff",
		"assets/preload/strings/gizmoloading_ske.json",
		"assets/preload/strings/gizmoloading_tex.json",
		"assets/preload/strings/strings.json",
		"assets/preload/ui/gfx_bg.png",
		"assets/preload/ui/gfx_loading.png",
		"assets/preload/ui/gizmoloading_tex.png"
	],
	"preloadstring": []
};